import {CanActivateFn} from '@angular/router';
import {Backend, PERMISSION} from '@generated-backend-types';
import {inject} from '@angular/core';
import {UserSessionService} from '../services/user-session.service';
import {ToastrService} from 'ngx-toastr';
import {TranslateService} from '@ngx-translate/core';
import {ModelPermission} from '../entities/model-permission.entity';
import RoleEnum = Backend.App.Enums.Auth.RoleEnum;

export const canActivateGuard: CanActivateFn = (route) => {
  const authService = inject(UserSessionService);
  const toastr = inject(ToastrService);
  const translateService = inject(TranslateService);

  const allPermissionsNeeded: (PERMISSION|ModelPermission)[] | undefined = route.data['allPermissionsNeeded'];
  const anyPermissionNeeded: (PERMISSION|ModelPermission)[] | undefined = route.data['anyPermissionNeeded'];

  const allPermissionsToCheck: (PERMISSION|ModelPermission)[] = [];
  allPermissionsNeeded?.forEach(function (permission) {
    if (typeof permission === 'object' && 'modelId' in permission && permission.modelId === 'id') {
      allPermissionsToCheck.push({ ...permission, modelId: route.params['id'] });
    } else {
      allPermissionsToCheck.push(permission);
    }
  });

  const anyPermissionsToCheck: (PERMISSION|ModelPermission)[] = [];
  anyPermissionNeeded?.forEach(function (permission) {
    if (typeof permission === 'object' && 'modelId' in permission && permission.modelId === 'id') {
      anyPermissionsToCheck.push({ ...permission, modelId: route.params['id'] });
    } else {
      anyPermissionsToCheck.push(permission);
    }
  });

  let canPermission = authService.hasAllPermission(allPermissionsToCheck ?? [])
  if (!canPermission) {
    toastr.warning(translateService.instant('misc.missing_permission', {missingPermissions: allPermissionsToCheck}));
  }

  if (canPermission && anyPermissionsToCheck && anyPermissionsToCheck.length > 0) {
    canPermission = authService.hasAnyPermission(anyPermissionsToCheck);
  }

  const allRolesNeeded: RoleEnum[] | undefined = route.data['allRolesNeeded'];
  const anyRoleNeeded: RoleEnum[] | undefined = route.data['anyRoleNeeded'];

  let canRole = authService.hasAllRoles(allRolesNeeded ?? [])
  if (!canRole) {
    toastr.warning(translateService.instant('misc.missing_role', {missingRoles: allRolesNeeded}));
  }

  if (canRole && anyRoleNeeded && anyRoleNeeded.length > 0) {
    canRole = authService.hasAnyRole(anyRoleNeeded);
  }

  return canPermission && canRole;
};
